// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  customGameModeDetailQueryOptions,
  customGameModeListQueryOptions,
} from '@/modules/custom-game-mode/custom-game-mode.hooks'

export const customGameModeRoute = createRoute({
  path: '/custom-game-modes',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const customGameModeListRoute = createRoute({
  getParentRoute: () => customGameModeRoute,
  path: '/',
  head: () => ({ meta: [{ title: 'Özel Oyun Modları' }] }),
  loader: async () => {
    await queryClient.ensureQueryData(
      customGameModeListQueryOptions({ page: 1, perPage: 10 })
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/custom-game-mode/pages/list-custom-game-mode.page')
  ),
})

export const customGameModeCreateRoute = createRoute({
  getParentRoute: () => customGameModeRoute,
  path: '/create',
  head: () => ({ meta: [{ title: 'Yeni Özel Mod' }] }),
  component: lazyRouteComponent(
    () =>
      import('@/modules/custom-game-mode/pages/create-custom-game-mode.page')
  ),
})

export const customGameModeEditRoute = createRoute({
  getParentRoute: () => customGameModeRoute,
  path: '/$id/edit',
  head: () => ({ meta: [{ title: 'Özel Mod Düzenle' }] }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(customGameModeDetailQueryOptions(id))
  },
  component: lazyRouteComponent(
    () => import('@/modules/custom-game-mode/pages/edit-custom-game-mode.page')
  ),
})
